import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { encryption, decrypt } from '@/utils/crypto.js'
Vue.prototype.encryption = encryption // 加密
Vue.prototype.decrypt = decrypt // 解密
Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");

